export default __webpack_public_path__ + "static/media/Article Icon - Grey.11b25095.svg";